import { render, staticRenderFns } from "./receivedListDetail.vue?vue&type=template&id=4038a7e0&"
import script from "./receivedListDetail.vue?vue&type=script&lang=js&"
export * from "./receivedListDetail.vue?vue&type=script&lang=js&"
import style0 from "./receivedListDetail.vue?vue&type=style&index=0&id=4038a7e0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports